import { Card } from "@/components/ui/card";
import { useUserRatings } from "@/hooks/useUserRatings";
import { Trophy } from "lucide-react";
import { ILeader } from "@/lib/community";
import { LeaderRow } from "@/components/community/LeaderRow";
import { ProfileLevels } from "../components/community/ProfileLevels";
import { useTranslation } from "react-i18next";

export function LeaderRows({
  list,
  total,
}: {
  list: ILeader[];
  total: boolean;
}) {
  return (
    <ol className="mt-2 space-y-2 md:space-y-3">
      {list.map((user, i) => (
        <LeaderRow total={total} key={user.user_id} user={user} index={i} />
      ))}
    </ol>
  );
}

function SkeletonRow() {
  return (
    <div className="flex items-center gap-2 md:gap-3 py-1.5 md:py-2 px-2 animate-pulse">
      <div className="w-6 h-6 md:w-7 md:h-7 rounded bg-gray-200" />
      <div
        className="rounded-full bg-gray-200"
        style={{ width: 32, height: 32 }}
      />
      <div className="flex-1 min-w-0 ml-2">
        <div className="h-3.5 md:h-4 rounded bg-gray-200 mb-1 w-2/4" />
        <div className="h-2.5 md:h-3 rounded bg-gray-100 w-1/3" />
      </div>
      <div className="h-4 md:h-5 rounded bg-gray-200 w-8 md:w-10" />
    </div>
  );
}

function LeaderboardColumn({
  title,
  query,
  total = false,
}: {
  title: string;
  query: { isLoading: boolean; error: any; data?: any[] };
  total?: boolean;
}) {
  return (
    <Card className="p-4 md:p-5 rounded-xl shadow-lg border w-full bg-background">
      <h2 className="font-semibold mb-3 md:mb-4 text-base md:text-xl text-gray-800 flex items-center gap-2 dark:text-white">
        <Trophy className="w-5 h-5 md:w-6 md:h-6 text-blue-400" />
        {title}
      </h2>
      {query.isLoading ? (
        <div className="space-y-1.5 md:space-y-2">
          {Array.from({ length: 5 }).map((_, idx) => (
            <SkeletonRow key={idx} />
          ))}
        </div>
      ) : query.error ? (
        <div className="text-red-500 text-center">Ошибка загрузки</div>
      ) : (
        <LeaderRows total={total} list={query.data?.slice(0, 10) ?? []} />
      )}
    </Card>
  );
}

export function LeaderboardPage() {
  const { week, month, total } = useUserRatings();
  const { t } = useTranslation();
  return (
    <div className="px-4 md:px-0">
      <ProfileLevels />
      <div className="mx-auto pt-4 pb-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        <LeaderboardColumn
          title={t("community.leaderBoardCard.week")}
          query={week}
        />
        <LeaderboardColumn
          title={t("community.leaderBoardCard.month")}
          query={month}
        />
        <LeaderboardColumn
          title={t("community.leaderBoardCard.allTime")}
          query={total}
          total={true}
        />
      </div>
    </div>
  );
}
